import { render, staticRenderFns } from "./contactDetail.vue?vue&type=template&id=33c094b9&scoped=true"
import script from "./contactDetail.vue?vue&type=script&lang=js"
export * from "./contactDetail.vue?vue&type=script&lang=js"
import style0 from "./contactDetail.vue?vue&type=style&index=0&id=33c094b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c094b9",
  null
  
)

export default component.exports